import { cn } from "../lib/cn";
import { SamklangLoader } from "./samklang-loader";

export type PageLoaderProps = {
  className?: string;
  label?: string;
  /** Full viewport-ish height so layout does not jump */
  fullHeight?: boolean;
};

/**
 * Soft Headspace-style loading state between screens / while data hydrates.
 */
export function PageLoader({
  className,
  label = "samklang",
  fullHeight = true,
}: PageLoaderProps) {
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center justify-center gap-5 px-8",
        fullHeight && "min-h-[55vh]",
        className
      )}
      role="status"
      aria-live="polite"
      aria-label="Laddar"
    >
      <div className="relative flex h-20 w-20 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-surface-raised/70 shadow-sm" />
        <SamklangLoader size="lg" className="relative" label={label} />
      </div>
      <p className="text-sm font-medium tracking-wide text-foreground-muted">
        {label}
      </p>
    </div>
  );
}

/** Soft skeleton blocks for content placeholders */
export function ScreenSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn("mx-auto w-full max-w-lg space-y-6 px-6 pt-8", className)}
      aria-hidden
    >
      <div className="space-y-3">
        <div className="h-8 w-2/5 animate-pulse rounded-2xl bg-surface-muted" />
        <div className="h-4 w-4/5 animate-pulse rounded-xl bg-surface-muted/80" />
      </div>
      <div className="h-48 animate-pulse rounded-lg bg-surface-raised shadow-sm" />
      <div className="h-40 animate-pulse rounded-lg bg-surface-raised shadow-sm" />
      <div className="h-32 animate-pulse rounded-lg bg-surface-raised shadow-sm" />
    </div>
  );
}
